module.exports = __webpack_public_path__ + "static/media/zoomout.d2318cf3.svg";